import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Navbar,
  NavbarBrand,
  Nav,
  Col,
  Row,
  Button,
  Container,
  Card,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "reactstrap";
import logo from "../../../images/logo.png";
import { useNavigate, useParams } from "react-router-dom";
import { USER_LICENSEPLAN, DOG_LISTING_URL } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { getAgencyId } from "../../common/CommonFunctions";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import BackButtonSvg from "../../common/BackButtonSvg";
import { GUEST_CHOOSE_PLAN } from "../../../constants/RoutePaths";
import { JSONParser } from "../../../functions/Helper";
import { Info } from "../../common/Info";
import { useDispatch } from "react-redux";
import { ALL_DOG } from "../../../redux/actions/ActionTypes";
import moment from "moment";
import dogImg from "../../../images/dog.png";

function GuestLicence() {
  const [loading, setLoading] = useState(false);
  const [licenseplandata, setlicenseplandata] = useState([]);
  const { userId } = useParams();
  const [DogId, setDogId] = useState("");
  const [dogName, setDogname] = useState("Select Pet");
  const history = useNavigate();
  const [DogDetails, setDogDetails] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const back = () => {
    history(-1);
  };

  let GetDog = async () => {
    console.log(authHeader(), "authHeader(),");
    setLoading(true);
    const config = {
      method: "GET",
      url: DOG_LISTING_URL,
      headers: authHeader(),
      params: {
        userId: userId,
        agencyId: getAgencyId(),
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setDogDetails(data);
        dispatch({ type: ALL_DOG, payload: data });
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  let GetPlan = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: USER_LICENSEPLAN,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;

      // data.map((i) => {
      //   setCategory(i.category);
      // });

      if (status === "Success") {
        setlicenseplandata(data);
      }
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  const dogOnChange = (e) => {
    const { dogid } = e.currentTarget.dataset;
    const dogname = e.currentTarget.textContent;
    setDogId(dogid);
    setDogname(dogname);
  };

  useEffect(() => {
    GetPlan();
    GetDog();
  }, []);

  const getLicenseId = (e) => {
  };
  return (
    <div>
      {loading && <CustomPageLoading />}

      <Navbar color="white" className="usr-nav" expand="md">
        <NavbarBrand>
          <img className="logo" src={logo} alt=""/>
        </NavbarBrand>
        <Nav className="mr-auto" navbar></Nav>
      </Navbar>
      <div className="agency-wrapper">
        <Container>
          <div className="page-title">
            <h4>
              New License
              <Tooltip
                isOpen={id === "newlicese" && tooltipOpen}
                target={"newlicese"}
                toggle={() => tooltiptoggle("newlicese")}
              >
                View point of sale transaction information
              </Tooltip>
              <span id={"newlicese"}>
                <Info />
              </span>
            </h4>

            <div className="top-btn">
              <Button onClick={back} color="primary">
                {" "}
                <BackButtonSvg />
                Back
              </Button>
            </div>
          </div>

          <Card body className="mt-4">
            <Row>
              <Col sm="12" md={{ size: 6, offset: 3 }}>
                <div className="create-step">
                  <h4>
                    Choose Your Pet{" "}
                    <Tooltip
                      isOpen={id === "choosepet" && tooltipOpen}
                      target={"choosepet"}
                      toggle={() => tooltiptoggle("choosepet")}
                    >
                      Choose from the registered pets on customer account that
                      you want to license
                    </Tooltip>
                    <span id={"choosepet"}>
                      <Info />
                    </span>{" "}
                  </h4>

                  {DogDetails === 0 ? (
                    <p style={{ color: "red", textAlign: "center" }}>
                      Please add your pet to proceed with licence{" "}
                      {
                        <Link to={`/agency/guest-details/${userId}`}>
                          Add pet here
                        </Link>
                      }
                    </p>
                  ) : (
                    <center>
                      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>{dogName}</DropdownToggle>
                        <DropdownMenu>
                          {DogDetails.map((name) => (
                            <DropdownItem
                              onClick={dogOnChange}
                              data-dogId={name.dogId}
                              data-dogName={name.dogName}
                            >
                              <img
                              alt=""
                                src={
                                  name.dogImageUrl ? name.dogImageUrl : dogImg
                                }
                                style={{
                                  border: "2px solid #10264f",
                                  borderRadius: "50%",
                                  width: "50px",
                                  height: "50px",
                                }}
                              />{" "}
                              {name.dogName}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </center>
                  )}
                  <br />
                </div>
              </Col>
            </Row>

            <div className="create-step">
              <h4>
                Choose Plan
                <Tooltip
                  isOpen={id === "chooseplan" && tooltipOpen}
                  target={"chooseplan"}
                  toggle={() => tooltiptoggle("chooseplan")}
                >
                  Choose license type for registered pet
                </Tooltip>
                <span id={"chooseplan"}>
                  <Info />
                </span>{" "}
              </h4>
            </div>

            <Row className="mt-4 create-plan plan-list">
              {licenseplandata.map((record) => (
                <>
                  {record.planName ? (
                    <Col md="6" lg="6" xl="4" className="mb-4">
                      <div className="box">
                        <h4>{record.planName}</h4>
                        <h1>
                          <strong>$</strong>
                          {parseFloat(record.planAmount).toFixed(2)}
                        </h1>
                        <span>
                          {record.isLifeTimePlan && "Life Time Plan"}

                          {!!record.validTo && (
                            <>
                              {" "}
                              <span>Till Date</span>{" "}
                              {moment(record.validTo).format("MM-DD-YYYY")}
                            </>
                          )}
                          {!!record.planDuration &&
                            record.planDuration + "/ month"}
                        </span>
                        <ul>
                          <li>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17.011"
                              height="17.011"
                              viewBox="0 0 17.011 17.011"
                            >
                              <path
                                id="Icon_material-check-box"
                                data-name="Icon material-check-box"
                                d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                                transform="translate(-4.5 -4.5)"
                                fill="#fff"
                              />
                            </svg>
                            {record.isKennelLicense
                              ? "kennel license"
                              : record.isParkLicense
                              ? "Park License"
                              : record.isDogLicense
                              ? "Dog License"
                              : ""}
                          </li>
                        </ul>
                        <p>{record.planDescription}</p>
                        {JSONParser(record.categoryDetails, []).map((i) => (
                          <ul>
                            <li>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17.011"
                                height="17.011"
                                viewBox="0 0 17.011 17.011"
                              >
                                <path
                                  id="Icon_material-check-box"
                                  data-name="Icon material-check-box"
                                  d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                                  transform="translate(-4.5 -4.5)"
                                  fill="#fff"
                                />
                              </svg>
                              {i.categoryName}
                            </li>
                          </ul>
                        ))}

                        <Link
                          to={{
                            pathname:
                              GUEST_CHOOSE_PLAN +
                              "/" +
                              `${userId}/${record.licensePlanId}/${DogId}`,
                          }}
                        >
                          <div className="btn-section">
                            <Button
                              disabled={DogId === ""}
                              color="danger"
                              onClick={getLicenseId}
                              data-licensePlanId={record.licensePlanId}
                            >
                              Choose Plan
                            </Button>
                          </div>
                        </Link>
                      </div>
                    </Col>
                  ) : (
                    "No plan is Active"
                  )}{" "}
                </>
              ))}
            </Row>
            {/* <Link to={`/agency/guest-details/${userId}`}>Add pet here</Link> */}
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default GuestLicence;
